module.exports = __webpack_public_path__ + "img/home-hero.81c0171d.jpg";